export default __webpack_public_path__ + "static/media/logo_color_Cardio_Protecccion.845559ee.png";